import { render, staticRenderFns } from "./HotArticleCard.vue?vue&type=template&id=31815007&"
import script from "./HotArticleCard.vue?vue&type=script&lang=js&"
export * from "./HotArticleCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports